/* Myverse announcement bar dismiss — sessionStorage. */
(function () {
  var STORAGE_KEY = 'mv-announcement-dismissed';
  var BAR_SELECTOR = '.utility-bar';

  function hideBar(bar) {
    if (!bar) return;
    bar.classList.add('mv-announcement-dismissed');
    bar.setAttribute('aria-hidden', 'true');
  }

  function init() {
    var bar = document.querySelector(BAR_SELECTOR);
    if (!bar) return;

    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') {
        hideBar(bar);
        return;
      }
    } catch (e) { /* sessionStorage blocked — proceed without persistence */ }

    var btn = bar.querySelector('.mv-announcement-dismiss');
    if (!btn) return;

    btn.addEventListener('click', function () {
      hideBar(bar);
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
